import {FlashsaleType} from "../../../helpers/loadFlashsales";
import {createRoot} from "react-dom/client";
import React, {Suspense, useEffect} from "react";
import {useTranslation} from "react-i18next";
import FlashSaleTimer from "../../atoms/FlashSaleTimer";

export function rootFlashsaleSlideRender(
  slideAnchor: HTMLAnchorElement,
  flashSale: FlashsaleType,
  isRenderedCallback: () => void,
) {
  slideAnchor.href = flashSale.path;
  slideAnchor.dataset.gaPromoName = flashSale.headline;
  slideAnchor.dataset.gaPromoMediaId = flashSale.mediaId;

  const root = createRoot(slideAnchor);
  root.render(
    <Suspense fallback={null}>
      <RootFlashsaleSlide flashSale={flashSale} isRenderedCallback={isRenderedCallback} />
    </Suspense>,
  );
}

const RootFlashsaleSlide: React.FC<{flashSale: FlashsaleType; isRenderedCallback: () => void}> = ({
  flashSale,
  isRenderedCallback,
}) => {
  const {t} = useTranslation();

  useEffect(() => {
    isRenderedCallback();
  }, []);

  return (
    <>
      <div className="flash-sale__text">
        <div className="flash-sale__text-wrapper">
          <div className="flash-sale__text-content">
            <p className="cp-headline">{t("flashsale.inTheConnoxDeals")}</p>
            <h2>{flashSale.headline}</h2>
            <div className="flash-sale__timer-text">
              <FlashSaleTimer endDateString={flashSale.endDate} />
            </div>
            <span className="flash-sale__link">{t("flashsale.watchNow")}</span>
          </div>
        </div>
      </div>
      <div className="flash-sale__image">
        <img src={flashSale.blogCTAImg2x} alt={flashSale.imgAltText} />
        <p className="center">
          <span className="link">{t("flashsale.watchNow")}</span>
        </p>
      </div>
    </>
  );
};
